import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { Projects } from './components/Projects';
import { Toolchain } from './components/Toolchain';
import { Blog } from './components/Blog';
import { SiteFooter } from './components/SiteFooter';
interface AppProps {
  showAnnouncement?: boolean;
}
export function App({
  showAnnouncement = true
}: AppProps) {
  return <div className="min-h-full w-full bg-[#f7f7f8] font-sans text-ink" data-id="element-0" data-mp="2mluboumz01vx">
      {showAnnouncement && <AnnouncementBar data-id="element-1" data-mp="31aqdi9yfoio3" />}
      <div className="mx-auto w-full max-w-[1500px] border-x border-hairline bg-white" data-id="element-2" data-mp="31b8fzobovt4g">
        <SiteHeader data-id="element-3" data-mp="2wk9xqj754kyk" />
        <main data-id="element-4" data-mp="2wiyx2s8zrtbo">
          <Hero data-id="element-5" data-mp="2wj8fnurpiy7c" />
          <Projects data-id="element-6" data-mp="2wip36tktt20p" />
          <Toolchain data-id="element-7" data-mp="28ufp6dtutik4" />
          <Blog data-id="element-8" data-mp="28tw4ipctkg2e" />
        </main>
        <SiteFooter data-id="element-9" data-mp="28t4j27cxrypu" />
      </div>
    </div>;
}